import React from 'react';
import { Currency } from '@fiverr-private/currencies_plugin/dist/interface';
import { Domingo } from '@fiverr-private/domingo';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { ExpertCard as Card } from '@fiverr-private/listings';
import { Expert, SkillInfo } from '../../../shared/types';

interface ExpertCardProps {
    skill: SkillInfo;
    expert: Expert;
    currency?: Currency;
    onError?: (message: string) => void;
}

interface MutateUrlProps {
    cardUrl: string;
}

export const ExpertCard = ({ skill, expert, currency, onError }: ExpertCardProps) => {
    const { url: hostUrl } = getContext();

    const mutateUrl = ({ cardUrl }: MutateUrlProps): string => {
        // remove excessive path from host url and forward slash from the end of the string
        const trimmedHostUrl = Domingo(hostUrl).removePath().url.replace(/\/$/, '');
        const expertName = expert?.seller?.username;
        let path: string;

        // experts of pro skill should be opened in pro domain
        if (skill.isProSkill) {
            path = Domingo(`${trimmedHostUrl}${cardUrl}`).pro().url;
        } else if (expertName) {
            // non-pro skill experts should be opened in the same domain but replace freelancers path with sellers
            const sellerPath = pathfinder('seller_page', { username: expertName });
            const freelancerPath = pathfinder('freelancer_page', { username: expertName });
            path = cardUrl.replace(freelancerPath, sellerPath);
        } else {
            if (onError && typeof onError === 'function') {
                onError(`Expert doesn't have name: ${expert?.seller?.id}. Skill: ${skill.slug}. CardUrl: ${cardUrl}`);
            }
            // if pathfinder fails to find freelancer path then fallback to default cardUrl without 'freelancers'
            path = cardUrl.replace(/\/freelancers\//, '/');
        }

        return path;
    };

    return (
        <Card
            currency={currency}
            isPromoted={false}
            auctionId={undefined}
            promotedGigId={undefined}
            additionalInfo={undefined}
            {...expert}
            mutateUrl={(url: string) => mutateUrl({ cardUrl: url })}
            source="skill_pages"
            cardVariant="visual"
            contextReferrer="skill_page"
            pageName="skill_page"
            displayOptions={{
                showPrice: false,
                showContact: false,
                showSaveExpert: false,
                mainCta: 'seeProfile',
                showJobTitle: true,
                showSeeProfile: true,
            }}
        />
    );
};
